import { standardAction, errorAction } from "../common/actions";
import types from "./types";

const {
  VIDEO_ASSOCIATIONS_REQUEST,
  VIDEO_ASSOCIATIONS_SUCCESS,
  VIDEO_ASSOCIATIONS_FAILURE,
  VIDEO_ASSOCIATIONS_RESET,
  SET_VIDEO_TRANSCRIPT,
} = types;

const doVideoAssociationsRequest = (payload) =>
  standardAction(VIDEO_ASSOCIATIONS_REQUEST, payload);
const doVideoAssociationsSuccess = (payload) =>
  standardAction(VIDEO_ASSOCIATIONS_SUCCESS, payload);
const doVideoAssociationsFailure = (payload) =>
  errorAction(VIDEO_ASSOCIATIONS_FAILURE, payload);
const doVideoAssociationsReset = (payload) =>
  standardAction(VIDEO_ASSOCIATIONS_RESET, payload);

const setVideoDetailTranscript = (transcript) => ({
  type: SET_VIDEO_TRANSCRIPT,
  transcript,
});

export default {
  doVideoAssociationsRequest,
  doVideoAssociationsSuccess,
  doVideoAssociationsFailure,
  doVideoAssociationsReset,
  setVideoDetailTranscript,
};
